var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"grid grid-cols-1 gap-3"},_vm._l((_vm.insights),function(insight){return _c('ProfileInsight',{key:insight.id,attrs:{"heading":_vm.$t(
					`personality_results.key-insights.${insight.heading}.heading`
				),"body":_vm.$t(insight.body.insightKeys[0])}},[(insight.icon)?_c(insight.icon,{tag:"Component",staticClass:"shrink-0",attrs:{"size":"20"}}):_vm._e()],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }